import {
  certificateIssuanceReport,
  attendanceReport,
  certificatePendingReport,
  courseEnrollmentReport,
  instructorDailyAttendanceReport,
  instructorDashboardSummary,
  instructorAssessmentReport,
  instructorAssessmentReportDetails,
} from "constants/report";

const initialState = {
  certificateIssuanceReport: {},
  attendanceReport: {},
  certificatePendingReport: {},
  courseEnrollmentReport: {},
  instructorDailyAttendanceReport: {},
  instructorDashboardSummary: {},
  instructorAssessmentReport: {},
  instructorAssessmentReportDetails: {},
};

const report = (state = initialState, action) => {
  switch (action.type) {
    case certificateIssuanceReport:
      return {
        ...state,
        certificateIssuanceReport: action.payload,
      };

    case attendanceReport:
      return {
        ...state,
        attendanceReport: action.payload,
      };

    case certificatePendingReport:
      return {
        ...state,
        certificatePendingReport: action.payload,
      };

    case courseEnrollmentReport:
      return {
        ...state,
        courseEnrollmentReport: action.payload,
      };

    case instructorDailyAttendanceReport:
      return {
        ...state,
        instructorDailyAttendanceReport: action.payload,
      };

    case instructorDashboardSummary:
      return {
        ...state,
        instructorDashboardSummary: action.payload,
      };

    case instructorAssessmentReport:
      return {
        ...state,
        instructorAssessmentReport: action.payload,
      };

    case instructorAssessmentReportDetails:
      return {
        ...state,
        instructorAssessmentReportDetails: action.payload,
      };

    default:
      return state;
  }
};

export default report;
